export default {
    commentPlaceholder: 'Commenter sur cette actualité',
    comment: 'commentaire',
    comments: {
        less: 'Voir moins de commentaires',
        more: 'Voir tous les commentaires'
    },
    dateText: 'Publié le :DATE',
    likes: 'J\'aime',
    share: 'Partager',
    toComment: 'Commenter',
}